// extracted by mini-css-extract-plugin
module.exports = {"quick-access__block":"ClubUnimarcQuickAccess_quick-access__block__uFPeK","quick-access__icon":"ClubUnimarcQuickAccess_quick-access__icon__zOJPm"};